import clsx from "clsx";
import React from "react";

import { days } from "~/utils";

import styles from "./index.module.scss";

export default function Points({
  points,
  pointId,
  onSelectPoint,
  isBallon,
}: any) {
  return (
    <div className={clsx(isBallon && styles.ListBallon, styles.List)}>
      {points.map((shop: any) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        <div
          key={shop.ID}
          className={clsx(
            pointId === shop.ID && styles.ItemActive,
            styles.Item,
          )}
          onClick={() => {
            onSelectPoint(shop.ID);
          }}
        >
          <div className={styles.Icon}>
            {pointId === shop.ID && (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#1247A5" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17.5825 8.5708C17.973 8.96133 17.973 9.59449 17.5825 9.98502L11.9843 15.5832C11.5938 15.9738 10.9606 15.9738 10.5701 15.5832L7.29232 12.3055C6.90179 11.915 6.90179 11.2818 7.29232 10.8913C7.68284 10.5008 8.31601 10.5008 8.70653 10.8913L11.2772 13.4619L16.1683 8.5708C16.5588 8.18028 17.192 8.18028 17.5825 8.5708Z"
                  fill="white"
                />
              </svg>
            )}
          </div>

          <div className={styles.Info}>
            <div className={styles.Name}>{shop.NAME}</div>
            <div className={styles.Time}>{shop.WORK_TIME}</div>
          </div>

          <div className={styles.Pickup}>
            {shop.AVAL ? (
              <div>
                Можно забрать заказ:{" "}
                <span className={clsx(shop.DEL_DAYS === 0 && styles.Today)}>
                  {days(shop.DEL_DAYS)}
                </span>
              </div>
            ) : (
              <span />
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
